import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { NavLink } from "react-router-dom";
export default function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [isMenuActive, setIsMenuActive] = useState(false);
    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
        setIsOpen(false);
    };

    const closeMenu = () => {
        setIsMenuActive(false);
    };

    return (
        <header className="relative py-[10px] shadow-md">
            <div className="container flex items-center justify-between">
                <Link to={"/"}>
                    <img className="w-[110px] h-[65px]" src={require("../../assets/logo/logo.png")} alt="" />
                </Link>
                <nav className="d-none">
                    <ul className="flex items-center gap-[15px]">
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                Home
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                About us
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/services"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                Services
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/faq"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                FAQs
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                Contact us
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/claims"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                Claims
                            </NavLink>
                        </li>
                    </ul>
                </nav>
                <div className="flex items-center gap-[10px]">
                    <Link to={"/quote"} className="bg-[#294a6a] text-white py-[6px] px-[20px] rounded-[4px]">Free Quote</Link>
                    <button className={`menu ${isMenuActive ? "active" : ""}`} onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
            {isMenuActive && (
                <nav className="top-[101px] flex flex-col gap-[20px]">
                    <ul className="flex flex-col gap-4">
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                Home
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                About us
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/services"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                Services
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/faq"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                FAQs
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                Contact us
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/claims"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#294A6A] border-b-2 border-[#294A6A] font-bold" : "text-black"} hover:text-[#294A6A]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                Claims
                            </NavLink>
                        </li>
                    </ul>
                    <Link to={"/quote"} className="w-fit bg-[#294a6a] text-white py-[6px] px-[20px] rounded-[4px]">Free Quote</Link>
                </nav>
            )
            }
        </header>
    );
}